import { isString } from 'lodash-es';

const validFamilyValues = [
  "highlight",
  "page",
  "generic_file",
  "image",
  "notepad"
];
const validSortFieldValues = [
  "createdAt",
  "modifiedAt",
  "kind",
  "name"
];
function isFamilyFilter(value) {
  return isString(value) && validFamilyValues.includes(value);
}
function isSortField(value) {
  return validSortFieldValues.includes(value);
}
function isSortOrder(value) {
  return value === "ASC" || value === "DESC";
}

export { isFamilyFilter, isSortField, isSortOrder };
//# sourceMappingURL=queryOptionGuards.js.map
